module.exports = __webpack_public_path__ + "static/img/arthroscopy-05.7b3d56f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-05.jpg
// module id = NXwt
// module chunks = 52